/* campaign-currency — localise campaign "spend" thresholds to the shopper's
 * currency. Shows the SAME round number with the local symbol for the
 * currencies we sell in (GBP/USD/EUR); falls back to GBP (£) — the store base /
 * discount currency — everywhere else, so pounds show by default.
 * The active currency comes from the store's currency app (window.Currency),
 * with a cookie fallback. Threshold is a fixed round number, NOT an exchange-
 * rate conversion, so it always reads cleanly (£50 / $50 / €50).
 */
(function () {
  'use strict';
  if (window.__mpCampaignCurrency) return; // load-once guard (used by multiple sections)
  window.__mpCampaignCurrency = true;

  var SYMBOLS = { GBP: '£', USD: '$', EUR: '€' }; // currencies we sell in
  var COUNTRIES = { GBP: 'UK', USD: 'US', EUR: 'EU' }; // region label per currency
  var DEFAULT = 'GBP'; // store base / discount currency — show pounds by default

  function activeCurrency() {
    if (window.Currency && window.Currency.currentCurrency) return window.Currency.currentCurrency;
    var m = document.cookie.match(/(?:^|;\s*)currency=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : DEFAULT;
  }

  function render() {
    var cur = activeCurrency();
    var symbol = SYMBOLS[cur] || SYMBOLS[DEFAULT]; // default to £ (base) where unknown
    var country = COUNTRIES[cur] || COUNTRIES[DEFAULT];

    // Spend threshold: round number + local symbol + "+"
    var nodes = document.querySelectorAll('[data-campaign-threshold]');
    for (var i = 0; i < nodes.length; i++) {
      var amt = nodes[i].getAttribute('data-amount') || '50';
      nodes[i].textContent = symbol + amt + '+';
    }
    // Shipping amount: same round number + local symbol, no "+"
    var amts = document.querySelectorAll('[data-campaign-amount]');
    for (var j = 0; j < amts.length; j++) {
      amts[j].textContent = symbol + (amts[j].getAttribute('data-amount') || '50');
    }
    // Region label — one country shown at a time, follows the active currency
    var regions = document.querySelectorAll('[data-campaign-country]');
    for (var k = 0; k < regions.length; k++) {
      regions[k].textContent = country;
    }
  }

  function init() {
    render();
    // The currency app may load/apply after us — re-render shortly after.
    setTimeout(render, 400);
    setTimeout(render, 1200);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('currency:update', render); // fired by the currency app
  window.addEventListener('pageshow', render);
})();
